import { Info } from 'lucide-react';
import { Popover } from './Popover';

interface HelpPopoverProps {
  /** Accessible name of the info button, e.g. "Erklärung anzeigen". */
  label: string;
  /** Explanation text; line breaks (`\n`) start a new paragraph. */
  text: string;
}

/**
 * Info button that opens a short explanation of a figure or term next to it (FAFD-56).
 * Same trigger as the offer amount breakdown, but plain text only.
 */
export function HelpPopover({ label, text }: HelpPopoverProps) {
  return (
    <Popover label={label} trigger={<Info className="w-3.5 h-3.5" strokeWidth={2} />}>
      <div className="min-h-0 flex-1 overflow-y-auto space-y-2 px-3 py-2.5 text-[12px] leading-relaxed text-slate-600">
        {text.split('\n').map((paragraph, index) => (
          // why: paragraphs of a fixed string never reorder, and equal lines would collide as text keys.
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </Popover>
  );
}
